export default __webpack_public_path__ + "static/media/carson-project-1.f6f857ef.webp";